/**
 * Parameters for calculating the team chest target score.
 */
export const teamChestTargetScore = {
  min: 600,
  max: 3000,
  multipleOf: 50,
  pointsPerPlayer: 15,
};

/**
 * List of rewards that can be granted from the team chest, with parameters for randomization.
 */
export const teamChestRewards = {
  gems: {
    min: 100,
    max: 300,
  },
  boosters: {
    min: 1,
    max: 3,
    types: ['dart', 'bullet', 'drill', 'roulette'] as const,
  },
  powerUps: {
    min: 1,
    max: 3,
    types: ['bomb', 'rocket', 'cube'] as const,
  },
};
